/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Notifications_Preferences_Category_NameInputs */

const de_notifications_preferences_category_name = /** @type {(inputs: Notifications_Preferences_Category_NameInputs) => LocalizedString} */ (i) => {
	if (i?.category === "infos") return /** @type {LocalizedString} */ (`Tipps, Updates & Programm-Highlights`);
	if (i?.category === "offers") return /** @type {LocalizedString} */ (`Angebote & Vorteile`);
	if (i?.category === "surveys") return /** @type {LocalizedString} */ (`Umfragen`);
	if (i?.category === "partners") return /** @type {LocalizedString} */ (`Gewinnspiele & Aktionen`);
	return /** @type {LocalizedString} */ (``)
	
};

/** @type {(inputs: Notifications_Preferences_Category_NameInputs) => LocalizedString} */
const en_notifications_preferences_category_name = de_notifications_preferences_category_name;

/**

* @param {Notifications_Preferences_Category_NameInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_category_name = /** @type {((inputs: Notifications_Preferences_Category_NameInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Category_NameInputs, { locale?: "de" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_category_name(inputs)
	return en_notifications_preferences_category_name(inputs)
});